import { deriveTicketUrl } from '@/lib/utils/ticket-env';
import { isWebsiteBrowser } from '@/lib/website-auth/browser';

// Read from the document for the same reason as `isWebsiteBrowser`.
function isGuestAuthBrowser(tenant: string): boolean {
  if (typeof document === 'undefined') return false;
  return document.documentElement.dataset.guestAuthTenant === tenant;
}

/** Where this tenant's agent answers. The same-origin proxies take the tenant from the host, so
 *  the browser never names it to them; the agent itself takes it in its path. Both proxies serve
 *  the chat turn only: a sign-in tenant can't also use resumable streams or server-side history
 *  until they get the same treatment. On a ticket environment's page, that environment's agent. */
export function chatAgentUrl(tenant: string): string {
  if (isWebsiteBrowser(tenant)) return '/api/website';
  if (isGuestAuthBrowser(tenant)) return '/api/guest';
  return `${browserChatApiBase()}/${tenant}`;
}

/** The chat API this page talks to directly: on a ticket environment's page, that environment's.
 *  The server names it from the Host it served the page on, because a demo serves a ticket
 *  environment under a clean name that the page's own address doesn't carry. */
export function browserChatApiBase(): string {
  const ticketEnvId =
    typeof document === 'undefined' ? undefined : document.documentElement.dataset.ticketEnvId;
  return deriveTicketUrl(process.env.NEXT_PUBLIC_CHAT_API_BASE_URL ?? '', ticketEnvId ?? null);
}
